import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { OccasionGeniusEvent } from 'src/app/core/types/models/occasion-genius-event.model';

import { AuthService } from 'src/app/core/services/auth.service';
import { GoogleAnalyticService } from 'src/app/core/services/google-analytic.service';
import { FavoritesProviderService } from 'src/app/core/services/favorites-provider.service';

import { OccasionGeniusDetailsDialogComponent } from '../../dialogs/occasion-genius-details-dialog/occasion-genius-details-dialog.component';

import moment from 'moment';

@Component({
  selector: 'app-occasion-genius-card',
  templateUrl: './occasion-genius-card.component.html',
  styleUrls: ['./occasion-genius-card.component.scss'],
  imports: [TranslateModule, NgxSkeletonLoaderModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OccasionGeniusCardComponent {
  @Input({ required: true }) countryName: string;
  @Input({ required: true }) cityName: string;
  @Input() placeId: number | string = -1;
  @Input({ required: false }) event: OccasionGeniusEvent | null = null;
  @Input({ required: false }) events: OccasionGeniusEvent[] = [];
  @Input() isFetching: boolean = false;
  @Input() disableHurt: boolean = false;

  @Output() onUnFavourite = new EventEmitter<void>();

  #matDialog = inject(MatDialog);

  constructor(
    protected readonly favoritesProviderService: FavoritesProviderService,
    private readonly googleAnalyticService: GoogleAnalyticService,
    private readonly authService: AuthService,
    private cdr: ChangeDetectorRef,
  ) {}

  get eventPreview(): OccasionGeniusEvent {
    return this.event ? this.event : this.events[0];
  }

  public readonly m = moment;

  protected readonly eSvgIcons = ESvgIcons;

  public toggleHurt(e: MouseEvent): void {
    e.preventDefault();
    e.stopPropagation();

    this.favoritesProviderService.checkUserAuth(
      {
        favoriteId: this.eventPreview.uuid,
        placeId: Number(this.placeId),
        provider: 'occasion_genius',
      },
      this.eventPreview,
      this.cityName,
      (isDelete) => {
        if (isDelete) this.onUnFavourite.emit();
        if (!isDelete) {
          if (!isDelete) {
            this.googleAnalyticService.setAddToWishlistAnalytic({
              whishlist_category: 'events',
              merchant: 'booking',
              service_country: this.countryName,
              service_city: this.cityName,
              category_name: 'events',
              service_title: `events: ${this.eventPreview.name}`,
              userID: this.authService.userId,
            });
          }
        }
        this.cdr.markForCheck();
      },
    );
  }

  public handleShowMore(e: MouseEvent): void {
    e.preventDefault();
    e.stopPropagation();

    this.#matDialog.open(OccasionGeniusDetailsDialogComponent, {
      data: {
        events: this.events,
        countryName: this.countryName,
        cityName: this.cityName,
      },
      panelClass: 'mobile-dialog-container',
    });
  }
}
